import { Component } from '@angular/core'
import { MbMobileNavigationsModel } from '../../../my-account.module'
import { environment } from '../../../../../../environments/environment'

@Component({
  selector: 'mb-myaccount-mobile-navigation',
  templateUrl: './mb-myaccount-mobile-navigation.component.html',
  styleUrls: ['./mb-myaccount-mobile-navigation.component.scss']
})
export class MbMyaccountMobileNavigationComponent {

  environment = environment
  navigationItems: MbMobileNavigationsModel[] = [
    {
      text: 'mbMyAccount.navigation.home',
      icon: 'Home_Outline.svg',
      link: '/myaccount',
      activeIcon: 'Home_Solid.svg'
    },
    {
      text: 'mbMyAccount.navigation.addressBook',
      icon: 'Book_Outline.svg',
      link: '/myaccount/address-book',
      activeIcon: 'Book_Solid.svg'
    },
    {
      text: 'mbMyAccount.navigation.orderHistory',
      icon: 'Order_History_Outline.svg',
      link: '/myaccount/orders',
      activeIcon: 'Order_History_Solid.svg'
    },
    {
      text: 'mbMyAccount.navigation.profileSettings',
      icon: 'User_Outline.svg',
      link: environment.myAccount.hostedPages.baseUrl+environment.myAccount.hostedPages.profilePage,
      activeIcon: 'User_Solid.svg',
      isExternal: true,
    },
    {
      text: 'mbMyAccount.navigation.newsletter',
      icon: 'Bell_Outline.svg',
      link: '/resources/newsletter-sign-up.html',
      activeIcon: 'Bell_Solid.svg',
    },
    {
      text: 'mbMyAccount.navigation.wishlist',
      icon: 'Heart_Outline.svg',
      link: '/myaccount/wishlist',
      activeIcon: 'Heart_Solid.svg'
    }
  ]
}
